import { IAppointmentDetail } from 'interfaces/appointments';

export const getDentistWorkingHour = (appointment: IAppointmentDetail) => {
  if (!appointment.linkedAppointment && appointment.isSplitScheduling) {
    const preferredDentistName =
      appointment.metadata?.preferredDentist?.displayName || null;

    return preferredDentistName
      ? `Doctor's working day (${preferredDentistName})`
      : `Doctor's working day (No Preference)`;
  }

  return '';
};
